import { render } from "./ThePathUniverse.vue?vue&type=template&id=ae037a86&scoped=true"
import script from "./ThePathUniverse.vue?vue&type=script&lang=js"
export * from "./ThePathUniverse.vue?vue&type=script&lang=js"

import "./ThePathUniverse.vue?vue&type=style&index=0&id=ae037a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae037a86"]])

export default __exports__